import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'layout',
        component: () => import('../views/layout/index.vue'),
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: '首页',
                component: () => import('../views/home/index.vue')
            },
            {
                path: '/user',
                name: '用户管理',
                component: () => import('../views/user/index.vue')
            },
            {
                path: '/category/main',
                name: '商品大类管理',
                component: () => import('../views/category/main/index.vue')
            },
            {
                path: '/category/sub',
                name: '商品小类管理',
                component: () => import('../views/category/sub/index.vue')
            },
            {
                path: '/product',
                name: '商品管理',
                component: () => import('../views/product/index.vue')
            },
            {
                path: '/banner',
                name: '轮播图管理',
                component: () => import('../views/banner/index.vue')
            },
            {
                path: '/order',
                name: '订单管理',
                component: () => import('../views/order/index.vue')
            },
            {
                path: '/business',
                name: '商家管理',
                component: () => import('../views/business/index.vue')
            },
            {
                path: '/wallet/info',
                name: '钱包概览',
                component: () => import('../views/wallet/info/index.vue')
            },
            {
                path: '/wallet/flow',
                name: '资金流水',
                component: () => import('../views/wallet/flow/index.vue')
            },
            {
                path: '/wallet/settlement',
                name: '结算记录',
                component: () => import('../views/wallet/settlement/index.vue')
            },
            {
                path: '/wallet/withdraw',
                name: '提现记录',
                component: () => import('../views/wallet/withdraw/index.vue')
            },
            {
                path: '/wallet/audit',
                name: '提现审核',
                component: () => import('../views/wallet/audit/index.vue')
            },
            {
                path: '/system/password',
                name: '修改密码',
                component: () => import('../views/system/password/index.vue')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index.vue')
    }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
